<template>
  <Tabs :value="nowTab" @on-click="tabClick">
    <TabPane
      :label="$t('PB_Team_Information')"
      name="name1"
      v-if="
        !this.$route.query.pageLink || this.$route.query.pageLink == 'name1'
      "
      ><tabPane1Vue ref="tabPane1Vue"/></TabPane
    ><!-- 团队信息 -->
    <!-- 新增的员工档案团队情况跳转显示 -->
    <TabPane
      :label="$t('Successors_Info')"
      name="name2"
      v-if="!this.$route.query.pagename || this.$route.query.tab2 == '1'"
      ><tabPane3Vue ref="tabPane3Vue"/></TabPane
    ><!-- 继任者盘点 -->
    <!-- <tabPane2Vue v-show="!showTab"/> -->
    <Button
      @click="returnPage"
      v-if="this.$route.query.pageLink && !this.$route.query.pagename"
      slot="extra"
      ><!-- 返回 -->{{ $t("Return") }}</Button
    >
  </Tabs>
</template>
<script>
import tabPane1Vue from "./teamInfoComponents/tabPane1.vue";
import tabPane2Vue from "./teamInfoComponents/tabPane2.vue";
import tabPane3Vue from "./teamInfoComponents/tabPane3.vue";
export default {
  components: {
    tabPane1Vue,
    tabPane2Vue,
    tabPane3Vue
  },

  data() {
    return {
      nowTab: "name1",
      showTab: false
    };
  },
  created() {
    this.$route.query.empFlag && this.$route.query.pagename
      ? (document.title = this.$route.query.pagename + "的人才卡片")
      : "";
    this.$route.query.pagename && !this.$route.query.empFlag
      ? (document.title = this.$route.query.pagename + "的团队概览")
      : "";
    this.$route.query.pageLink
      ? (this.nowTab = this.$route.query.pageLink)
      : (this.nowTab = "name1");
    this.$route.query.plan
      ? (this.showTab = this.$route.query.plan)
      : (this.showTab = false);
  },
  mounted() {
    if (this.nowTab == "name1") {
      if (this.$route.query.id) {
        this.$nextTick(() => {
          this.$refs.tabPane1Vue.btnShow = false;
        });
      }
      this.$nextTick(() => {
        this.$route.query.id
          ? (this.$refs.tabPane1Vue.id = this.$route.query.id)
          : "";
        this.$route.query.serialnumber
          ? (this.$refs.tabPane1Vue.serialnumber = this.$route.query.serialnumber)
          : "";
        this.$route.query.empLoyeeDisabled
          ? (this.$refs.tabPane1Vue.empLoyeeDisabled = this.$route.query.empLoyeeDisabled)
          : "";
        this.$refs.tabPane1Vue.getData();
      });
    } else if (this.nowTab == "name2") {
      this.$nextTick(() => {
        this.$refs.tabPane3Vue.getData();
      });
    } else {
      this.$nextTick(() => {
        this.$route.query.id
          ? (this.$refs.tabPane1Vue.id = this.$route.query.id)
          : "";
        this.$route.query.serialnumber
          ? (this.$refs.tabPane1Vue.serialnumber = this.$route.query.serialnumber)
          : "";
        this.$refs.tabPane1Vue.getData();
      });
    }
    if (!this.$route.query.pagename) {
      if (this.$route.query.id) {
        this.$refs.tabPane3Vue.id = this.$route.query.id;
        this.$refs.tabPane3Vue.beTopLevel = this.$route.query.beTopLevel;
        this.$route.query.serialnumber
          ? (this.$refs.tabPane3Vue.serialnumber = this.$route.query.serialnumber)
          : "";
      }
    }
  },
  methods: {
    tabClick(name) {
      this.nowTab = name;
      if (this.nowTab == "name2") {
        this.$refs.tabPane3Vue.getData();
      } else {
        this.$refs.tabPane1Vue.getData();
      }
    },
    returnPage() {
      this.$router.back();
      sessionStorage.setItem("Teamback",1)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/MyQuery/TeamInfo.vue